var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('span',{staticClass:"txt",style:({color:_vm.txtColor,fontSize: _vm.fontSize+'px'})},[_vm._v(_vm._s(_vm.title))]),(_vm.rightShow)?_c('span',{staticClass:"img"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }